import clsx from 'clsx'
import React, { FC } from 'react'

type Props = {
  selected: boolean
}

const RadioDot: FC<Props> = ({ selected }) => {
  return (
    <div className='flex-shrink-0 flex items-center justify-center cursor-pointer rounded-full w-6 h-6 bg-lightYellow overflow-hidden'>
      <div
        className={clsx('w-2 h-2 rounded-full', {
          'bg-dark': selected,
          'bg-transparent': !selected,
        })}
      ></div>
    </div>
  )
}

export default RadioDot
